<template>
  <div class="hubble-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$v = H₀ · d$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>星系距离 (D)</label>
            <span class="val">{{ dist.toFixed(1) }} <small>Mpc</small></span>
          </div>
          <div class="hud-item orange">
            <label>退行速度 (v)</label>
            <span class="val">{{ speed.toFixed(0) }} <small>km/s</small></span>
          </div>
          <div class="hud-item green">
             <label>红移偏移 (z)</label>
             <span class="val">{{ (speed / 300000).toFixed(4) }} </span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 宇宙背景网格膨胀 (Expansion Grid) -->
          <g transform="translate(225, 120)">
             <circle v-for="r in 4" :key="'r'+r" :r="r * 40 * (1 + expansion*0.01)" fill="none" stroke="#334155" stroke-dasharray="2,2" />
          </g>

          <!-- 银河系 (Observer) -->
          <circle cx="225" cy="120" r="8" fill="#fbbf24" filter="url(#glow-h)" />
          <text x="225" y="145" text-anchor="middle" fill="#94a3b8" font-size="9">银河系 (Center)</text>

          <!-- 遥远星系 (Target Galaxy) -->
          <g :transform="`translate(${225 + dist * (1 + expansion*0.01) * 3}, 120)`">
             <circle r="6" fill="#0ea5e9" />
             <!-- 红移光波演示 (Redshifted Waves) -->
             <path :d="generateRedshiftPath" fill="none" :stroke="waveColor" stroke-width="2" />
             <text y="20" text-anchor="middle" fill="#0ea5e9" font-size="10">退行中...</text>
          </g>

          <defs>
             <filter id="glow-h"><feGaussianBlur stdDeviation="3" result="blur"/><feComposite in="SourceGraphic" in2="blur" operator="over"/></filter>
          </defs>
        </svg>

        <div class="physics-caption">
           规律：星系离开我们的速度与其距离成正比。这证明了宇宙空间本身正在均匀膨胀。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">哈勃常数 H₀ (膨胀速率)：{{ expansion }}</label>
                 <el-slider v-model="expansion" :min="65" :max="75" :step="0.1" size="small"></el-slider>
              </div>
              <div class="flex-1">
                 <label class="s-label">测量星系距离 d：{{ dist }} Mpc</label>
                 <el-slider v-model="dist" :min="10" :max="50" size="small"></el-slider>
              </div>
           </div>
        </div>
        
        <!-- 原子专业高对比度卡片加固 -->
        <div class="discovery-card-discovery-tir" v-latex>
           <div class="icon-wrap"><i class="el-icon-odometer"></i></div>
           <div class="text-content">
             <p><strong>实战物理/宇宙演化：</strong>哈勃定律是发现“大爆炸”的直接证据。<strong>解惑：</strong>空间不是空洞的舞台，它在自我“拉伸”。<strong>观察：</strong>调节距离滑块。你会发现距离越远的星系，不仅离我们更远，且远离我们的**速度增长越快**，发出的光也被拉得越红。这解释了星系并没有真正“飞走”，而是中间的空间长出来了。
             </p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'HubbleLawExpandsViz',
  data() {
    return {
      expansion: 70, // H0 average
      dist: 20
    }
  },
  computed: {
    speed() { return this.expansion * this.dist; },
    waveColor() {
       const redshift = this.speed / 300000;
       return redshift > 0.01 ? "#f43f5e" : "#0ea5e9";
    },
    generateRedshiftPath() {
       const shift = (this.speed / 5000);
       let d = "M -40,0 ";
       for(let x=-40; x<0; x+=2) {
          d += `L ${x},${Math.sin(x*(0.8 - shift))*5}`;
       }
       return d;
    }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.hubble-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
